module.exports = __webpack_public_path__ + "img/email_icon.9f3667be.svg";